import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { GridOptions } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-validate-vin-search',
  templateUrl: './validate-vin-search.component.html',
  styleUrls: ['./validate-vin-search.component.scss'],
})

export class ValidateVinSearchComponent implements OnInit, OnChanges {
  @Output() makeItem = new EventEmitter<any>();
  @Output() modelItem = new EventEmitter<any>();
  @Output() close = new EventEmitter<boolean>();
  @Input() makeArray: any[] = [];
  @Input() modelArray: any[] = [];
  @Input() typeSearch: string;
  gridMake: GridOptions;
  gridModel: GridOptions;
  gridMakeData: any[] = [];
  gridModelData: any[] = [];
  selectedRow: any[] = [];

  constructor(private sweetAlertHelper: SweetAlertHelper) {
    this.onInitGridMake();
    this.onInitGridModel();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['makeArray'] && this.makeArray.length > 0) {
      this.onInitGridMake();
    }
    if (changes['modelArray'] && this.modelArray.length > 0) {
      this.onInitGridModel();
    }
  }

  ngOnInit() {}

  onInitGridMake() {
    this.gridMake = <GridOptions> {
      enableSorting: true,
      enableColResize: true,
      enableFilter: true,
      rowSelection: 'single',
      columnDefs: [
        {
          colId: 'id',
          width: 40,
          checkboxSelection: true,
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 500,
        },
      ],
      onGridReady: () => {
        if (this.makeArray.length > 0 && this.typeSearch === 'Make') {
          this.gridMakeData = this.makeArray;
        }
      },
    };
    this.gridMakeData = [];
  }

  onInitGridModel() {
    this.gridModel = <GridOptions> {
      enableSorting: true,
      enableColResize: true,
      enableFilter: true,
      rowSelection: 'single',
      columnDefs: [
        {
          colId: 'id',
          width: 40,
          checkboxSelection: true,
        },
        {
          headerName: 'Name',
          field: 'name',
          width: 500,
        },
      ],
      onGridReady: () => {
        if (this.modelArray.length > 0 && this.typeSearch === 'Model') {
          this.gridModelData = this.modelArray;
        }
      },
    };
    this.gridModelData = [];
  }

  onFilter(event: any) {
    if (this.typeSearch === 'Model') {
      this.gridModel.api.setQuickFilter(event.target.value);
    } else {
      this.gridMake.api.setQuickFilter(event.target.value);
    }
  }

  onRowDoubleClicked(event: any) {
    if (this.typeSearch === 'Model') {
      this.modelItem.emit(event.data.name);
    } else {
      this.makeItem.emit(event.data.name);
    }
  }

  onSelectionMake() {
    this.selectedRow = this.gridMake.api.getSelectedRows();
    if (this.selectedRow.length > 0) {
      this.makeItem.emit(this.selectedRow[0].name);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        text: 'Please select a row',
        type: 'info',
      });
    }
  }

  onSelectionModel() {
    this.selectedRow = this.gridModel.api.getSelectedRows();
    if (this.selectedRow.length > 0) {
      this.modelItem.emit(this.selectedRow[0].name);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        text: 'Please select a row',
        type: 'info',
      });
    }
  }

  onSave() {
    if (this.typeSearch === 'Model') {
      this.onSelectionModel();
    } else {
      this.onSelectionMake();
    }
  }

  onCancel() {
    this.close.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/validate-vin/validate-vin-search/validate-vin-search.component.ts